import React, { useState } from 'react';
import { Box, Button, Dialog, DialogContent, AppBar, Toolbar, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close'; 
import AddIcon from '@mui/icons-material/Add';     
import TechActionTimeline from './TechActionTimeline';
import TechActionForm from './TechActionForm';

const TechActionLog = ({ 
    events, 
    actionEvents,    
    onSaveAction, 
    onDeleteAction, 
    isCalFull,
    selectedDate,    
    onDateChange,
    shouldResetForm,
    setShouldResetForm     
}) => {
    const [selectedSchedule, setSelectedSchedule] = useState(null);
    const [isFormOpen, setIsFormOpen] = useState(false);
    // 모바일 팝업 타이틀 제어를 위한 모드 상태 추가 ('create' | 'edit')
    const [formMode, setFormMode] = useState('create');

    // 1. 타임라인에서 일정을 클릭한 경우 (수정 모드)
    const handleSelectSchedule = (scheduleData) => {
        setSelectedSchedule(scheduleData);
        if(scheduleData?.id == null) {
            setFormMode('create'); // 수정 모드로 설정
        } else {
            setFormMode('edit'); // 수정 모드로 설정
        }
        
        setIsFormOpen(true);
    };

    // 2. 우측 하단 플로팅 버튼을 클릭한 경우 (신규 등록 모드)
    const handleOpenForm = () => {
        setSelectedSchedule(null); // 신규 등록이므로 선택된 스케줄 초기화
        setFormMode('create'); // 등록 모드로 설정
        setIsFormOpen(true);
    };

    const handleCloseForm = () => {
        setIsFormOpen(false);
    };

    const handleSaveAndClose = async (...args) => {
        await onSaveAction(...args);
        setIsFormOpen(false);
    };

    const handleDeleteAndClose = async (...args) => {
        await onDeleteAction(...args);
        setIsFormOpen(false);
    };

    return (
        <Box 
            sx={{ 
                display: 'flex', 
                flexDirection: { xs: 'column', md: 'row' }, 
                width: '100%', 
                height: '100%',
                gap: 4,
                p: 2,
                backgroundColor: '#ffffff',
                position: 'relative' 
            }}
        >
            {/* 모바일에서만 보이는 폼 열기 플로팅 버튼 */}
            <Button
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
                onClick={handleOpenForm}
                sx={{
                    display: { xs: 'flex', md: 'none' },
                    position: 'fixed',
                    bottom: 24,
                    right: 24,
                    zIndex: 1000,
                    borderRadius: 50,
                    boxShadow: 3,
                    px: 3,
                    py: 1.5
                }}
            >
                일정 등록
            </Button>

            {/* 왼쪽: 타임라인 */}
            <Box sx={{ flex: { xs: 'none', md: 2 } }}>
                <TechActionTimeline 
                    event={events}
                    actionEvents={actionEvents} 
                    selectedDate={selectedDate} 
                    onDateChange={onDateChange}
                    onSelectSchedule={handleSelectSchedule}
                />
            </Box>

            {/* 오른쪽: PC용 고정 폼 */}
            <Box 
                sx={{ 
                    display: { xs: 'none', md: 'block' }, 
                    flex: { xs: 'none', md: 3 },
                    p: 0.5
                }}
            >
                <TechActionForm 
                    selectedSchedule={selectedSchedule}
                    selectedDate={selectedDate}
                    onDateChange={onDateChange}
                    onSaveAction={onSaveAction}
                    onDeleteAction={onDeleteAction}
                    shouldResetForm={shouldResetForm}
                    setShouldResetForm={setShouldResetForm}
                />
            </Box>

            {/* 모바일용 전체화면 팝업 폼 */}
            <Dialog
                fullScreen
                open={isFormOpen}
                onClose={handleCloseForm}
                sx={{ display: { xs: 'block', md: 'none' } }}
            >
                <AppBar sx={{ position: 'relative', backgroundColor: '#2196f3' }}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={handleCloseForm} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                        {/* 진입 경로(모드)에 따라 타이틀 텍스트 동적 변경 */}
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            {formMode === 'create' ? '일정 등록' : '일정 수정'}
                        </Typography>
                    </Toolbar>
                </AppBar>
                <DialogContent sx={{ p: 2, backgroundColor: '#ffffff' }}>
                    <TechActionForm 
                        selectedSchedule={selectedSchedule}
                        selectedDate={selectedDate}
                        onDateChange={onDateChange}
                        onSaveAction={handleSaveAndClose} 
                        onDeleteAction={handleDeleteAndClose} 
                        shouldResetForm={shouldResetForm}
                        setShouldResetForm={setShouldResetForm}
                    />
                </DialogContent>
            </Dialog>
        </Box>
    );
};

export default TechActionLog;
